import { createRetryableLoader } from "./retryable-loader";

export const loadSettings = createRetryableLoader(() => import("@/components/SettingsModal"));
export const loadImpromptu = createRetryableLoader(
  () => import("@/components/impromptu/ImpromptuExperience")
);

// Fill-in-the-gap remains eager: a tutor can deliver it in the first live turn.
